/**
 * PlatformENPlatformPageView
 *
 * Page component for PlatformENPlatformPageView
 * Path: /platform
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { PlatformENPlatformPageView as __PlatformENPlatformPageView } from '@/components/traits/PlatformENPlatformPageView';
import { PlatformENPlatformAnalyticsView as __PlatformENPlatformAnalyticsView } from '@/components/traits/PlatformENPlatformAnalyticsView';
import { PlatformENDemoLaunchDeskView as __PlatformENDemoLaunchDeskView } from '@/components/traits/PlatformENDemoLaunchDeskView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface PlatformENPlatformPageViewProps {
  // Add any page-level props here
}

export function PlatformENPlatformPageView(_props: PlatformENPlatformPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-platform:meta.title"],"description":["i18n/t","std-almadar-platform:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/platform"},{"locale":"ar","path":"/ar/platform"},{"locale":"sl","path":"/sl/platform"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__PlatformENPlatformPageView config={{ initPayload: __navState }} />
          <__PlatformENPlatformAnalyticsView config={{ initPayload: __navState }} />
          <__PlatformENDemoLaunchDeskView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default PlatformENPlatformPageView;
